// Importar Vuetify
import './vuetify';

// Los que no tiene configuracion custom, se exportan
export const PLUGINS = { };

// Ejemplo de Plugin que require configuracion
// -------------------------------------------
// import Vue from 'vue';
// import VueTimeago from 'vue-timeago';
// import TimeAgoConfig from '@pjn/vue-core/libs/TimeAgoConfig';

// Registrar aqui mismo con la config en lugar de exportar
// Vue.use(VueTimeago, TimeAgoConfig);
// -------------------------------------------
